<template>
  <b-row>
    <b-col cols="12">
      <leave-application-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import LeaveApplicationAddForm from './LeaveApplicationAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    LeaveApplicationAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
